import React, {useRef, useState} from 'react';
import {Modal} from 'antd';
import {defaultDialog} from "../../utils/defaultData";
import ModalDialog from "./ModalDialog";

const ModalBase = ({open, handleClose, rowData, ModalPage, tblData, url, entityModel, width = 900, className = '', modalOptions, resizable = false, ...rest}) => {
    const [dialog, setDialog] = useState(defaultDialog);
    const dialogRef = useRef(dialog);

    const handleSetDialog = (updates) => {
        setDialog((prevState) => {
            const newState = { ...prevState };
            updates.forEach((update) => {
                newState[update.key] = update.value;
            });
            dialogRef.current = newState;
            return newState;
        });
    };

    const modalWidth = resizable ? 'auto' : width;
    const modalStyle = resizable ? { maxWidth: 'none' } : { minWidth: 400, padding: 24 };
    const modalStyles = resizable ? {
        content: {
            resize: 'both',
            overflow: 'hidden',
            width: typeof width === 'number' ? `${width}px` : (width || '900px'),
            minWidth: 400,
            maxWidth: '95vw',
        },
        body: {
            overflowY: 'auto',
            maxHeight: 'calc(90vh - 110px)',
        },
    } : undefined;

    return (
        <>
            <Modal
                open={open}
                onCancel={handleClose}
                footer={null}
                centered
                maskClosable={true}
                destroyOnClose
                style={modalStyle}
                width={modalWidth}
                styles={modalStyles}
                className={className}
            >
                <ModalPage
                    record={rowData}
                    handleClose={handleClose}
                    tblData={tblData}
                    dialogRef={dialogRef}
                    handleSetDialog={handleSetDialog}
                    url={url}
                    entityModel={entityModel}
                    modalOptions={modalOptions}
                    {...rest}
                />
            </Modal>
            {dialog.open && (
                <ModalDialog dialog={dialog} handleSetDialog={handleSetDialog} />
            )}
        </>
    );
};

export default ModalBase;